module.exports = __webpack_public_path__ + "static/img/firework-03.cbc8b17.png";